import {
  Box, Grid, Stack, Tooltip,
} from '@mui/material';
import Lottie from 'lottie-react';
import { Masonry } from '@mui/lab';
import { InfoChip } from '../../components/CustomChip';
import { DASHBOARD_CARDS_ID } from '../../utils/constants';
import { AccountStats } from '../AccountStats';
import { WatchListDropdown, PersonaDropdown, StatusAndExpiry } from '../../modules/Dashboard';
import useDashboard from './useDashboard';
import { HourGlassJson } from './HourGlassJson';

export default function Dashboard({ isNewProp, isAppAnalytics }) {
  const {
    personaList,
    selectedPersona,
    handlePersonaChange,
    visibleBoxIds,
    boxComponents,
    packageUpdatedDate,
  } = useDashboard();

  return (
    <Grid container gap={2}>
      <Grid container item xs={12} justifyContent="space-between" alignItems="flex-start">
        <Stack direction="row" gap={2}>
          <PersonaDropdown
            personaList={personaList}
            selectedPersona={selectedPersona}
            handlePersonaChange={handlePersonaChange}
          />
        </Stack>

        <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
          <StatusAndExpiry />
          {isNewProp && isAppAnalytics && (
            <Stack direction="row" gap={1} alignItems="center">
              <Tooltip title="Data is coming, Please wait.">
                <Lottie animationData={HourGlassJson} loop autoplay style={{ width: 25, height: 25 }} />
              </Tooltip>

              <InfoChip
                icon
                sxProps={{ height: 'fit-content !important' }}
                type="multiline"
                color="info"
                label="Please wait while we retrieve your usage logs from your PBO org."
              />
            </Stack>
          )}
          {isAppAnalytics === false && (
          <InfoChip
            icon
            sxProps={{ height: 'fit-content !important' }}
            type="multiline"
            color="error"
            label="Please enable App Analytics Query for your package."
          />
          )}
          <InfoChip
            color="info"
            type="multiline"
            label={packageUpdatedDate?.latestTimestamp ? `Data Updated: ${packageUpdatedDate?.latestTimestamp}` : 'Data Unavailable'}
          />
          <WatchListDropdown />
        </Box>
      </Grid>
      {visibleBoxIds.includes(DASHBOARD_CARDS_ID.ACCOUNT_STATS) && (
        <Grid item xs={12}>
          <AccountStats />
        </Grid>
      )}
      <Masonry columns={{ xs: 1, sm: 2 }}>
        {visibleBoxIds.map((boxId) => boxComponents[boxId] && <Box key={boxId}>{boxComponents[boxId]}</Box>)}
      </Masonry>
    </Grid>
  );
}
